/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import { useNuxtApp } from 'nuxt/app';
import type Rollbar from 'rollbar';
import type { LogArgument } from 'rollbar';

export interface UseRollbarReturn {
	logError: (...args: LogArgument[]) => void;
	logWarning: (...args: LogArgument[]) => void;
	logInfo: (...args: LogArgument[]) => void;
}

export const useRollbar = (): UseRollbarReturn => {
	const { $rollbar } = useNuxtApp();

	const getRollbarInstance = (): Rollbar | null => {
		return $rollbar ? ($rollbar as Rollbar) : null;
	};

	const logError = (...args: LogArgument[]): void => {
		const rollbar = getRollbarInstance();
		if (!rollbar) return;

		rollbar.error(...args);
	};

	const logWarning = (...args: LogArgument[]): void => {
		const rollbar = getRollbarInstance();
		if (!rollbar) return;

		rollbar.warning(...args);
	};

	const logInfo = (...args: LogArgument[]): void => {
		const rollbar = getRollbarInstance();
		if (!rollbar) return;

		rollbar.info(...args);
	};

	return {
		logError,
		logWarning,
		logInfo,
	};
};
